import React from 'react';
import loader from '../assets/image/loader.svg';
import './Loader.css';

const Loader = () => {
    return (
        <div className='loader' aria-disabled={true}>
            <img src={loader} alt="loader" />
        </div>
    )
}

export default Loader;